import script from "./GatePass.vue?vue&type=script&setup=true&lang=ts"
export * from "./GatePass.vue?vue&type=script&setup=true&lang=ts"

import "./GatePass.vue?vue&type=style&index=0&id=457499b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-457499b9"]])

export default __exports__